<template>
  <BFormCheckbox v-bind="attrs" v-model="model" class="checkbox-field"
    ><slot
  /></BFormCheckbox>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue";
const attrs = useAttrs();

// Define props
const props = defineProps({
  modelValue: { type: Boolean, required: false, default: false },
});

// Define v-model computed property
const model = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

// Emit events
const emit = defineEmits(["update:modelValue"]);
</script>
<style lang="scss">
@use "@/sass/components/CheckboxField.scss" as *;
</style>
